export class Customer {
  areaCode: number;
  areaName: string;
  meterId: number;
  previousReading: number;
  currentReading: number;
  latitude: number;
  longitude: number;
  customerId: number;
  customerName: string;
  customerPhone: number;
  customerPhone2: number;
  customerPhone3: number;
  customerEmail: string;
  customerAddress: string;
  customerStatus: string;
  customerJoinedDate: string;
  customerUnitRate: number;
  defaultUnitRate: number;
  customerDueAmount: number;
  custType?: string;
  custSubType?: string; // Maps to cust_sub_type in database
  zone?: string; // Maps to zone in database
  rh?: number;
  wadarta?: number;
  rc?: number;
  customerAction: string;
}
